/* ═══════════════════════════════════════════════════════════════
   THEME JS (ships as assets/ero-spin-popup.js, after gsap.min.js)
   ═══════════════════════════════════════════════════════════════ */
(function () {
  "use strict";
  var root = document.getElementById("eroSpin");
  if (!root || !window.gsap) return;
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var PRIZES = JSON.parse(root.getAttribute("data-prizes"));
  var ORDER = [0, 1, 2, 3, 0, 1, 2, 3];                          // clockwise from 12: 10, 20, 15, 25, twice
  var COMPANY = root.getAttribute("data-company-id");
  var ENDPOINT = root.getAttribute("data-endpoint");               // the prize server (8.1b)
  var LIST_EMAIL = root.getAttribute("data-email-list"), LIST_SMS = root.getAttribute("data-sms-list");
  var KEY = "ero-spin-v1";
  var stage = root.querySelector(".ero-spin__stage");
  var wheelBox = root.querySelector(".ero-spin__wheel");
  var hostA = root.querySelector(".ero-spin__host--a"), hostB = root.querySelector(".ero-spin__host--b");
  var steps = root.querySelectorAll("[data-spin-step]");
  var live = root.querySelector("[data-spin-live]");
  var state = { step: 1, email: "", phone: "", prize: null, code: "", slice: 0, rot: 0, spinning: false, open: false };

  /* ── storage (try/catch: private mode and blocked storage) ── */
  function load() { try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) { return {}; } }
  function save(patch) { try { var s = load(); for (var k in patch) s[k] = patch[k]; localStorage.setItem(KEY, JSON.stringify(s)); } catch (e) {} }

  /* ═════ Wheel, drawn live. Units are desktop design px around the wheel centre;
     the 470 x 470 viewBox scales to 271 on mobile. ═════ */
  var NS = "http://www.w3.org/2000/svg";
  var R = { rim: 234.5, bulbRing: 220.2, bulb: 4.32, disc: 205, ring: 206, hub: 46.1, div0: 49.28, num: 116.4, off: 166.7, wedge0: 49.2 };
  var BULB_C = ["#00B8D4", "#9B6DFF", "#F06292"];
  var M = 1 / 0.5766;                                            // mobile: glows that keep their desktop px size
  function f(n) { return Math.round(n * 1000) / 1000; }
  function polar(r, deg) { var a = deg * Math.PI / 180; return [f(r * Math.sin(a)), f(-r * Math.cos(a))]; }
  /* parallel glow: each blur reads the source alpha, never the previous blur (glow standard) */
  function glow(id, color, layers, k, region) {
    var s = '<filter id="' + id + '" ' + (region || 'x="-60%" y="-60%" width="220%" height="220%"') + ' color-interpolation-filters="sRGB">', m = "";
    layers.forEach(function (L, i) {
      s += '<feFlood flood-color="' + color + '" flood-opacity="' + L[1] + '" result="t' + i + '"/>' +
        (L[2] ? '<feOffset in="SourceAlpha" dy="' + L[2] + '" result="o' + i + '"/>' : "") +
        '<feGaussianBlur in="' + (L[2] ? "o" + i : "SourceAlpha") + '" stdDeviation="' + f(L[0] / 2 * k) + '" result="b' + i + '"/>' +
        '<feComposite in="t' + i + '" in2="b' + i + '" operator="in" result="g' + i + '"/>';
      m += '<feMergeNode in="g' + i + '"/>';
    });
    return s + "<feMerge>" + m + '<feMergeNode in="SourceGraphic"/></feMerge></filter>';
  }
  var PURPLE6 = [0.42, 0.84, 2.95, 5.90, 10.11, 17.69].map(function (r) { return [r, 0.7]; });
  var USR = 'filterUnits="userSpaceOnUse" x="-270" y="-270" width="540" height="540"';
  function defs() {
    var d = "";
    d += glow("eroSpinPurpleD", "#9B6DFF", PURPLE6, 1, USR) + glow("eroSpinPurpleM", "#9B6DFF", PURPLE6, 11.7 / 17.69 * M, USR);
    d += glow("eroSpinHubD", "#9B6DFF", [[11.7, 0.8], [26, 0.45]], 1) + glow("eroSpinHubM", "#9B6DFF", [[11.7, 0.8], [26, 0.45]], M);
    d += glow("eroSpinMarkD", "#9B6DFF", [[5, 1]], 1) + glow("eroSpinMarkM", "#9B6DFF", [[5, 1]], M);
    d += glow("eroSpinPinD", "#000", [[6, 0.5, 4]], 1, 'x="-80%" y="-50%" width="260%" height="200%"').replace("<feMerge>", '<feFlood flood-color="#FFD54F" flood-opacity=".7" result="tg"/><feGaussianBlur in="SourceAlpha" stdDeviation="4" result="bg"/><feComposite in="tg" in2="bg" operator="in" result="gg"/><feMerge><feMergeNode in="gg"/>');
    d += glow("eroSpinPinM", "#000", [[6 * M, 0.5, 4 * M]], 1, 'x="-120%" y="-80%" width="340%" height="260%"').replace("<feMerge>", '<feFlood flood-color="#FFD54F" flood-opacity=".7" result="tg"/><feGaussianBlur in="SourceAlpha" stdDeviation="' + f(4 * M) + '" result="bg"/><feComposite in="tg" in2="bg" operator="in" result="gg"/><feMerge><feMergeNode in="gg"/>');
    d += glow("eroSpinWedge", "#FFD54F", [[5.3, 1], [12.3, 0.8]], 1, USR);
    [["Cyan", "#00B8D4"], ["Purple", "#9B6DFF"], ["Teal", "#00C9B1"], ["Pink", "#F06292"]].forEach(function (c) {
      var L = [[1, 1], [2, 1], [6, 1], [12, 1]];
      d += glow("eroSpinLabel" + c[0] + "D", c[1], L, 1, 'x="-60%" y="-120%" width="220%" height="340%"') + glow("eroSpinLabel" + c[0] + "M", c[1], L, M, 'x="-90%" y="-200%" width="280%" height="500%"');
    });
    /* bulb gradients: clear glass when off, white-hot core in the bulb colour when lit, halo in place of a blur */
    d += '<radialGradient id="eroSpinBulbOff" cx="38%" cy="34%" r="75%"><stop offset="0" stop-color="#fff" stop-opacity=".42"/><stop offset=".5" stop-color="#fff" stop-opacity=".14"/><stop offset="1" stop-color="#fff" stop-opacity=".06"/></radialGradient>';
    BULB_C.forEach(function (c, i) {
      d += '<radialGradient id="eroSpinBulbOn' + i + '" cx="38%" cy="34%" r="72%"><stop offset="0" stop-color="#fff"/><stop offset=".5" stop-color="' + c + '"/><stop offset="1" stop-color="' + c + '" stop-opacity=".85"/></radialGradient>';
      d += '<radialGradient id="eroSpinHalo' + i + '"><stop offset="0" stop-color="' + c + '" stop-opacity=".7"/><stop offset=".35" stop-color="' + c + '" stop-opacity=".62"/><stop offset=".53" stop-color="' + c + '" stop-opacity=".375"/><stop offset=".7" stop-color="' + c + '" stop-opacity=".14"/><stop offset=".85" stop-color="' + c + '" stop-opacity=".03"/><stop offset="1" stop-color="' + c + '" stop-opacity="0"/></radialGradient>';
    });
    d += '<radialGradient id="eroSpinSliceA" gradientUnits="userSpaceOnUse" cx="0" cy="0" r="205"><stop offset="0" stop-color="#120D2A"/><stop offset=".18" stop-color="#120D2A"/><stop offset=".46" stop-color="#231848"/><stop offset="1" stop-color="#3A2671"/></radialGradient>';
    d += '<radialGradient id="eroSpinSliceB" gradientUnits="userSpaceOnUse" cx="0" cy="0" r="205"><stop offset="0" stop-color="#0A0E2E"/><stop offset=".18" stop-color="#0A0E2E"/><stop offset=".46" stop-color="#0F1946"/><stop offset="1" stop-color="#142A6B"/></radialGradient>';
    PRIZES.forEach(function (p, i) {
      d += '<radialGradient id="eroSpinAccent' + i + '" gradientUnits="userSpaceOnUse" cx="0" cy="0" r="205"><stop offset="0" stop-color="' + p.accent + '" stop-opacity="0"/><stop offset=".58" stop-color="' + p.accent + '" stop-opacity="0"/><stop offset="1" stop-color="' + p.accent + '" stop-opacity=".34"/></radialGradient>';
    });
    d += '<radialGradient id="eroSpinInner" gradientUnits="userSpaceOnUse" cx="0" cy="0" r="205"><stop offset="0" stop-color="#9B6DFF" stop-opacity="0"/><stop offset=".87" stop-color="#9B6DFF" stop-opacity="0"/><stop offset="1" stop-color="#9B6DFF" stop-opacity=".45"/></radialGradient>';
    d += '<radialGradient id="eroSpinHubFill" gradientUnits="userSpaceOnUse" cx="0" cy="0" r="46.1"><stop offset="0" stop-color="#2A1F55"/><stop offset="1" stop-color="#150F28"/></radialGradient>';
    d += '<radialGradient id="eroSpinHubRing" gradientUnits="userSpaceOnUse" cx="0" cy="0" r="46.1"><stop offset="0" stop-color="#9B6DFF" stop-opacity="0"/><stop offset=".72" stop-color="#9B6DFF" stop-opacity="0"/><stop offset="1" stop-color="#9B6DFF" stop-opacity=".5"/></radialGradient>';
    d += '<linearGradient id="eroSpinPinFill" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#FFF4C2"/><stop offset=".45" stop-color="#FFD54F"/><stop offset="1" stop-color="#C98D10"/></linearGradient>';
    return d;
  }
  function sector(r0, r1, a0, a1) {
    var p0 = polar(r1, a0), p1 = polar(r1, a1);
    if (!r0) return "M0 0L" + p0 + "A" + r1 + " " + r1 + " 0 0 1 " + p1 + "Z";
    var q0 = polar(r0, a1), q1 = polar(r0, a0);
    return "M" + polar(r0, a0) + "L" + p0 + "A" + r1 + " " + r1 + " 0 0 1 " + p1 + "L" + q0 + "A" + r0 + " " + r0 + " 0 0 0 " + q1 + "Z";
  }
  var bulbsLit = [];
  function buildWheel() {
    var VB = 'viewBox="-235 -235 470 470"';
    /* 1. rim and bulbs (fixed) */
    var rim = '<defs>' + defs() + '</defs><circle r="' + R.rim + '" fill="#0B0920"/><circle r="' + R.rim + '" fill="none" stroke="#fff" stroke-opacity=".9" stroke-width="1" data-glow="purple"/>';
    var off = "", lit = "";
    for (var k = 0; k < 72; k++) {
      var p = polar(R.bulbRing, k * 5), ci = k % 3;
      off += '<circle cx="' + p[0] + '" cy="' + p[1] + '" r="' + R.bulb + '" fill="url(#eroSpinBulbOff)" stroke="#fff" stroke-opacity=".3" stroke-width=".66"/><circle cx="' + f(p[0] - 1.41) + '" cy="' + f(p[1] - 1.6) + '" r="1.03" fill="#fff" opacity=".55"/>';
      lit += '<g class="bulb-lit c' + ci + '" data-k="' + k + '"><circle cx="' + p[0] + '" cy="' + p[1] + '" r="20.2" fill="url(#eroSpinHalo' + ci + ')"/><circle cx="' + p[0] + '" cy="' + p[1] + '" r="' + R.bulb + '" fill="url(#eroSpinBulbOn' + ci + ')"/><circle cx="' + f(p[0] - 1.41) + '" cy="' + f(p[1] - 1.6) + '" r="1.13" fill="#fff" opacity=".95"/></g>';
    }
    rim += '<g>' + off + '</g><g class="bulbs" data-lit="0">' + lit + '</g>';
    /* 2. disc (turns) */
    var disc = "", lose = "", win = "", divs = "", labels = "";
    ORDER.forEach(function (pi, i) {
      var a0 = i * 45, a1 = a0 + 45, d = sector(0, R.disc, a0, a1), pr = PRIZES[pi];
      disc += '<path d="' + d + '" fill="url(#eroSpinSlice' + (i % 2 ? "B" : "A") + ')"/><path d="' + d + '" fill="url(#eroSpinAccent' + pi + ')"/>';
      lose += '<path class="sl-lose" data-i="' + i + '" d="' + d + '" fill="#000" fill-opacity=".6"/>';
      win += '<path class="sl-win" data-i="' + i + '" d="' + d + '" fill="#fff" fill-opacity=".22" style="display:none"/>';
      var e0a = polar(R.div0, a0 - 0.349), e0b = polar(R.div0, a0 + 0.349), e1a = polar(R.disc, a0 - 0.349 * 2.5 / 0.6 * R.div0 / R.disc), e1b = polar(R.disc, a0 + 0.349 * 2.5 / 0.6 * R.div0 / R.disc);
      divs += '<path d="M' + e0a + "L" + e1a + "L" + e1b + "L" + e0b + 'Z"/>';
      var th = a0 + 22.5;
      labels += '<g class="label" data-i="' + i + '" transform="rotate(' + th + ')">' +
        '<g transform="translate(0 ' + (-R.num) + ') rotate(-90)"><text class="num" data-glow="' + pr.glow + '" text-anchor="middle" dominant-baseline="central" font-family="IBM Plex Mono, ui-monospace, monospace" font-weight="400" font-size="30.34" letter-spacing="-0.61" fill="#fff">' + pr.pct + '%</text></g>' +
        '<g transform="translate(0 ' + (-R.off) + ') rotate(-90)"><text text-anchor="middle" dominant-baseline="central" font-family="ERO Future, sans-serif" font-weight="400" font-size="13.94" letter-spacing="0.56" fill="#fff">OFF</text></g></g>';
    });
    disc += '<circle r="' + R.disc + '" fill="url(#eroSpinInner)"/>' + lose + win;
    disc += '<g fill="#fff" fill-opacity=".95" data-glow="purple">' + divs + '</g>';
    disc += '<g class="wedge"><path class="wedge-glow" data-glow="wedge" fill="#FFD54F" d=""/><path class="wedge-line" d="" fill="#FFD54F" fill-opacity=".2" stroke="#FFD54F" stroke-width="5.33"/></g>';
    disc += labels;
    /* 3. ring, hub and pin (fixed) */
    var top = '<circle r="' + R.ring + '" fill="none" stroke="#fff" stroke-width="2" data-glow="purple"/>' +
      '<circle r="' + R.hub + '" fill="url(#eroSpinHubFill)" stroke="#fff" stroke-width="2" data-glow="hub"/><circle r="' + R.hub + '" fill="url(#eroSpinHubRing)"/>' +
      '<g transform="translate(-21.696 -21.696)" data-glow="mark"><path fill="#fff" d="M 21.143 0.163 C 21.488 -0.055 21.918 -0.054 22.261 0.165 L 42.863 13.306 C 43.191 13.515 43.391 13.893 43.391 14.300 L 43.391 41.430 C 43.391 42.951 41.831 43.891 40.605 43.109 L 21.810 31.125 C 21.741 31.077 21.651 31.077 21.581 31.125 L 2.788 43.109 C 1.561 43.892 0.000 42.951 0 41.430 L 0 14.240 C 0 13.832 0.201 13.453 0.531 13.244 L 21.143 0.163 Z M 22.287 12.059 C 21.927 11.811 21.464 11.811 21.104 12.059 L 9.594 19.981 C 8.807 20.522 8.271 21.774 8.473 22.748 C 8.768 24.162 9.863 24.957 10.990 24.957 C 11.463 24.957 11.942 24.816 12.369 24.522 L 21.104 18.510 C 21.464 18.262 21.927 18.262 22.287 18.510 L 31.022 24.522 C 32.503 25.540 34.603 24.716 34.946 22.593 C 35.112 21.570 34.624 20.549 33.804 19.985 L 22.287 12.059 Z"/></g>' +
      '<g class="pin"><g transform="translate(-17.46 -239.06)" data-glow="pin"><path d="M 17.46 0 C 27.063 0 34.92 7.857 34.92 17.46 C 34.92 26.19 28.13 31.525 23.28 38.8 L 17.46 52.38 L 11.64 38.8 C 6.79 31.525 0 26.19 0 17.46 C 0 7.857 7.857 0 17.46 0 Z" fill="url(#eroSpinPinFill)" stroke="#fff" stroke-width="1"/><circle cx="17.46" cy="16.49" r="6.305" fill="#150F28" stroke="#fff" stroke-width="1"/></g></g>';
    wheelBox.innerHTML = '<svg ' + VB + '>' + rim + '</svg><div class="ero-spin__disc"><svg ' + VB + '>' + disc + '</svg></div><svg ' + VB + '>' + top + '</svg>';
    bulbsLit = Array.prototype.slice.call(wheelBox.querySelectorAll(".bulb-lit"));
  }
  buildWheel();
  var discEl = wheelBox.querySelector(".ero-spin__disc"), discSvg = discEl.querySelector("svg");
  var bulbsG = wheelBox.querySelector(".bulbs"), pinEl = wheelBox.querySelector(".pin");

  /* ═════ Bulbs ═════
     Idle: every cyan bulb lights together, then every purple, then every pink (1.8 s cycle).
     Spinning: the same cycle three times faster, slowing with the wheel.
     Winner (Won step): a fill sweep from the pin down both sides, a fast all-bulb strobe, then all lit with a quick double blink every ~3.5 s. */
  var cycle = gsap.timeline({ repeat: -1, paused: true });
  cycle.call(setLit, ["0"], 0).call(setLit, ["1"], 0.6).call(setLit, ["2"], 1.2).to({}, { duration: 0.6 }, 1.2);
  function setLit(v) { bulbsG.setAttribute("data-lit", v); }
  function idle() { winTl && winTl.kill(); gsap.set(bulbsLit, { clearProps: "opacity" }); if (reduce) { setLit("0"); return; } cycle.timeScale(1).play(0); }
  var winTl = null;
  function winnerFlash() {
    cycle.pause(); winTl && winTl.kill();
    var wedge = discSvg.querySelector(".wedge");
    if (reduce) { setLit("all"); return; }
    setLit("none"); gsap.set(bulbsLit, { opacity: 0 });
    winTl = gsap.timeline();
    for (var s = 0; s <= 36; s++) {                               // both directions from 12 o'clock, meeting at 6
      var pair = [bulbsLit[s % 72]]; if (s > 0 && s < 36) pair.push(bulbsLit[72 - s]);
      winTl.set(pair, { opacity: 1 }, s * 0.018);
    }
    winTl.call(function () { gsap.set(bulbsLit, { clearProps: "opacity" }); setLit("all"); }, null, 0.7);
    for (var n = 0; n < 6; n++) {                                 // strobe: 6 flashes, 0.12 s apart
      winTl.call(setLit, ["none"], 0.82 + n * 0.24).set(wedge, { opacity: 0.35 }, 0.82 + n * 0.24)
           .call(setLit, ["all"], 0.94 + n * 0.24).set(wedge, { opacity: 1 }, 0.94 + n * 0.24);
    }
    winTl.set(wedge, { clearProps: "opacity" });
    var blink = gsap.timeline({ repeat: -1, repeatDelay: 3.1 });  // a quick double blink every ~3.5 s while the Won step is open
    blink.call(setLit, ["none"], 0).call(setLit, ["all"], 0.12).call(setLit, ["none"], 0.24).call(setLit, ["all"], 0.36);
    winTl.add(blink, "+=3.1");
  }

  /* ═════ Wheel states ═════ */
  function markLanded(i, on) {
    var pi = ORDER[i];
    discSvg.querySelectorAll(".sl-lose").forEach(function (n) { n.style.display = (+n.getAttribute("data-i") === i) ? "none" : ""; });
    discSvg.querySelectorAll(".sl-win").forEach(function (n) { n.style.display = (+n.getAttribute("data-i") === i) ? "" : "none"; });
    discSvg.querySelectorAll(".label").forEach(function (n) {
      var w = +n.getAttribute("data-i") === i; n.classList.toggle("is-win", w);
      n.querySelector(".num").setAttribute("font-size", w && on ? "35.26" : "30.34");
    });
    var d = sector(R.wedge0, R.disc, i * 45, i * 45 + 45);
    discSvg.querySelector(".wedge-glow").setAttribute("d", d); discSvg.querySelector(".wedge-line").setAttribute("d", d);
    discSvg.classList.toggle("is-landed", !!on);
  }
  function restRotation(i) { return ((360 - (i * 45 + 22.5)) % 360 + 360) % 360; }

  /* The prize is drawn on the server (8.1b). SPIN IT starts the wheel at once (a short ease-in, then full
     speed) while the server answers; then the wheel eases onto the slice the server picked. The hand-over
     keeps the speed: GSAP's power4.out is a quintic that starts at 5 x distance / time, so the time is set
     from the distance. */
  var SPIN_V = 2000;                                             // deg/s at full speed (the approved 6.2 s, 7-turn spin started near this)
  var spinTw = null, ramp = null, pinTick = 0;
  function flickPin() {                                           // the pin flicks as each divider passes it
    var t = Math.floor(gsap.getProperty(discEl, "rotation") / 45);
    if (t !== pinTick) { pinTick = t; gsap.fromTo(pinEl, { rotation: -12 }, { rotation: 0, duration: 0.2, ease: "power2.out", svgOrigin: "0 -222.57", overwrite: true }); }
  }
  function startSpin() {
    state.spinning = true; root.classList.add("is-spinning");
    if (reduce) { ramp = Promise.resolve(); return; }
    pinTick = Math.floor(state.rot / 45); cycle.timeScale(3);
    ramp = new Promise(function (ok) {                              // power2.in (cubic) ends at 3 x distance / time = SPIN_V
      spinTw = gsap.to(discEl, { rotation: state.rot + SPIN_V * 0.6 / 3, duration: 0.6, ease: "power2.in", onUpdate: flickPin, onComplete: function () {
        spinTw = gsap.to(discEl, { rotation: "+=" + SPIN_V * 30, duration: 30, ease: "none", onUpdate: flickPin });
        ok();
      } });
    });
  }
  function settle(distance, done) {                               // ease out from full speed over the given distance
    var r = gsap.getProperty(discEl, "rotation"), target = r + distance, dur = 5 * distance / SPIN_V;
    spinTw && spinTw.kill(); spinTw = null;
    gsap.to(cycle, { timeScale: 1, duration: dur, ease: "power4.out" });
    gsap.to(discEl, { rotation: target, duration: dur, ease: "power4.out", onUpdate: flickPin, onComplete: function () { end(target, done); } });
  }
  function end(target, done) { state.rot = target; state.spinning = false; root.classList.remove("is-spinning"); done(); }
  function landSpin(i, done) {                                    // onto slice i, about 6.2 s from full speed
    ramp.then(function () {
      if (reduce) {
        var target = state.rot - (state.rot % 360) + 360 + restRotation(i);
        gsap.timeline({ onComplete: function () { end(target, done); } }).to(discEl, { opacity: 0, duration: 0.2 })
          .set(discEl, { rotation: target }).to(discEl, { opacity: 1, duration: 0.25 });
        return;
      }
      var r = gsap.getProperty(discEl, "rotation"), want = SPIN_V * 6.2 / 5;
      var d = restRotation(i) - (((r + want) % 360) + 360) % 360;
      if (d < -180) d += 360; if (d > 180) d -= 360;
      settle(want + d, done);
    });
  }
  function stopSpin(done) {                                       // the server failed: coast to a stop
    ramp.then(function () {
      if (reduce) { end(state.rot, done); return; }
      settle(SPIN_V * 1.2 / 5, done);
    });
  }

  /* ═════ Klaviyo Client API (public site ID only; the list's own opt-in setting applies) ═════ */
  var REVISION = "2026-07-15";
  function klaviyo(path, body) {
    var url = "https://a.klaviyo.com/client/" + path + "/?company_id=" + COMPANY;
        return fetch(url, { method: "POST", headers: { "Content-Type": "application/vnd.api+json", "accept": "application/vnd.api+json", "revision": REVISION }, body: JSON.stringify(body) })
      .then(function (r) { return { ok: r.status === 202, status: r.status }; }, function () { return { ok: false, status: 0 }; });
  }
  function subscribe(attrs, channel, listId) {
    var subs = {}; subs[channel] = { marketing: { consent: "SUBSCRIBED" } };
    attrs.subscriptions = subs;
    return klaviyo("subscriptions", { data: { type: "subscription", attributes: { custom_source: "ERO Spin to Win", profile: { data: { type: "profile", attributes: attrs } } },
      relationships: { list: { data: { type: "list", id: listId } } } } });
  }
  function track(name, props, profile) {
    return klaviyo("events", { data: { type: "event", attributes: { properties: props, metric: { data: { type: "metric", attributes: { name: name } } },
      profile: { data: { type: "profile", attributes: profile } } } } });
  }

  /* ═════ Prize server (8.1b): POST the email, get back { pct, code }. Sent as text/plain so the browser
     needs no preflight; the server still checks the page's origin. No discount code lives in the page. ═════ */
  function askServer(email) {
    var ctl = window.AbortController ? new AbortController() : null;
    var timer = setTimeout(function () { if (ctl) ctl.abort(); }, 15000);
    return fetch(ENDPOINT, { method: "POST", headers: { "Content-Type": "text/plain" }, credentials: "omit", signal: ctl ? ctl.signal : undefined,
      body: JSON.stringify({ email: email, aid: anonId() }) })
      .then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (b) {
          clearTimeout(timer);
          if (r.ok && b.code && b.pct) return b;
          throw new Error(b.error || "http " + r.status);
        });
      }, function (e) { clearTimeout(timer); throw e; });
  }

  /* ═════ Steps ═════ */
  var noFocus = false;
  function showStep(n) {
    state.step = n; root.setAttribute("data-step", n);
    steps.forEach(function (s) { s.hidden = +s.getAttribute("data-spin-step") !== n; });
    stage.setAttribute("aria-labelledby", "eroSpinTitle" + n);
    var cur = root.querySelector('[data-spin-step="' + n + '"]');
    if (!reduce) gsap.fromTo(cur, { opacity: 0 }, { opacity: 1, duration: 0.35, ease: "power1.out" });
    var first = cur.querySelector(n === 3 ? "[data-spin-copy]" : "input:not([readonly])");
    if (first && state.open && !noFocus) setTimeout(function () { try { first.focus({ preventScroll: true }); } catch (e) {} }, 60);
  }
  function hostTo(b) {
    var on = b ? hostB : hostA, offEl = b ? hostA : hostB;
    if (reduce) { gsap.set(offEl, { autoAlpha: 0 }); gsap.set(on, { autoAlpha: 1 }); return; }
    gsap.to(offEl, { autoAlpha: 0, duration: 0.3 });
    gsap.fromTo(on, { autoAlpha: 0, y: 12, scale: 0.96 }, { autoAlpha: 1, y: 0, scale: 1, duration: 0.5, ease: "back.out(2)", delay: 0.1 });
  }
  function fillPrize() {
    root.querySelector("[data-spin-pct]").textContent = state.prize.pct + "%";
    root.querySelector("[data-spin-code]").textContent = state.code;
    root.querySelector("[data-spin-shop]").setAttribute("href", root.getAttribute("data-shop-url").replace("{code}", encodeURIComponent(state.code)));
  }
  function toStep2() {
    markLanded(state.slice, false);
    gsap.to(wheelBox, { opacity: 0.45, duration: reduce ? 0 : 0.4 });
    hostTo(true); showStep(2);
  }
  function toStep3(texted) {
    fillPrize(); markLanded(state.slice, true);
    gsap.to(wheelBox, { opacity: 1, duration: reduce ? 0 : 0.3 });
    showStep(3); winnerFlash();
    live.textContent = "You won " + state.prize.pct + " percent off. Your code is " + state.code + ".";
  }

  var emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  root.querySelector('[data-spin-step="1"]').addEventListener("submit", function (ev) {
    ev.preventDefault();
    if (state.spinning) return;
    var input = root.querySelector("#eroSpinEmail"), err = root.querySelector("#eroSpinErr1"), btn = root.querySelector("[data-spin-go]");
    var em = input.value.trim();
    if (!emailRe.test(em)) { err.textContent = "Enter a valid email so we know where to send your code."; input.focus(); return; }
    err.textContent = ""; btn.disabled = true; input.readOnly = true; state.email = em;
    startSpin();
    askServer(em).then(function (res) {
      var pi = -1, slots = [];
      PRIZES.forEach(function (p, k) { if (+p.pct === +res.pct) pi = k; });
      if (pi < 0) throw new Error("prize");                       // the wheel percents must match the server's prizes
      ORDER.forEach(function (q, i) { if (q === pi) slots.push(i); });
      state.prize = PRIZES[pi]; state.code = String(res.code); state.slice = slots[Math.floor(Math.random() * slots.length)];
      /* the subscribe carries the server's code, which the Klaviyo welcome email sends out */
      subscribe({ email: em, properties: { spin_prize: state.prize.pct, spin_code: state.code } }, "email", LIST_EMAIL).then(function (r) {
        if (!r.ok) { err.textContent = "We couldn't save your email. Check your connection and try again."; }
      });
      track("Spin to Win Spun", { prize: state.prize.pct, code: state.code, repeat: !!res.repeat }, { email: em, anonymous_id: anonId() });
      landSpin(state.slice, function () {
        markLanded(state.slice, true);
        save({ signedUp: Date.now(), prize: state.prize.pct, code: state.code });
        setTimeout(toStep2, reduce ? 300 : 1400);
      });
    }).catch(function (e) {
      stopSpin(function () {
        err.textContent = e && e.message === "email" ? "Enter a valid email so we know where to send your code." : "The wheel got stuck. Give it another spin in a moment.";
        btn.disabled = false; input.readOnly = false;
      });
    });
  });
  var tel = root.querySelector("#eroSpinTel");
  tel.addEventListener("input", function () {                     // (555) 555-0123 as they type
    var d = tel.value.replace(/\D/g, "").replace(/^1(?=\d{10})/, "").slice(0, 10), o = d;
    if (d.length > 6) o = "(" + d.slice(0, 3) + ") " + d.slice(3, 6) + "-" + d.slice(6); else if (d.length > 3) o = "(" + d.slice(0, 3) + ") " + d.slice(3);
    tel.value = o;
  });
  root.querySelector('[data-spin-step="2"]').addEventListener("submit", function (ev) {
    ev.preventDefault();
    var d = tel.value.replace(/\D/g, ""), err = root.querySelector("#eroSpinErr2");
    if (d.length !== 10) { err.textContent = "Enter a 10 digit US mobile number, or skip this step."; tel.focus(); return; }
    err.textContent = ""; state.phone = "+1" + d;
    subscribe({ email: state.email, phone_number: state.phone }, "sms", LIST_SMS);
    toStep3(true);
  });
  root.querySelector("[data-spin-skip]").addEventListener("click", function () { toStep3(false); });
  root.querySelector("[data-spin-copy]").addEventListener("click", function () {
    var b = this, code = root.querySelector("[data-spin-code]");
    function selectIt() { var r = document.createRange(); r.selectNodeContents(code); var s = getSelection(); s.removeAllRanges(); s.addRange(r); b.textContent = "Select"; }
    try { navigator.clipboard.writeText(code.textContent).then(function () { b.textContent = "Copied"; setTimeout(function () { b.textContent = "Copy"; }, 1600); }, selectIt); } catch (e) { selectIt(); }
  });

  /* ═════ Open, close, focus ═════ */
  var lastFocus = null;
  function open(why) {
    if (state.open) return;
    state.open = true; lastFocus = document.activeElement; root.hidden = false;
    refreshTab();                                                   // the reopen tab (8.1c) hides while the popup is open
    [hostA, hostB].forEach(function (im) { if (!im.getAttribute("src") && im.getAttribute("data-src")) im.setAttribute("src", im.getAttribute("data-src")); });
    document.documentElement.style.overflow = "hidden";
    if (!reduce) { gsap.fromTo(root, { opacity: 0 }, { opacity: 1, duration: 0.35, ease: "power1.out" }); gsap.fromTo(wheelBox, { scale: 0.92, rotation: -8 }, { scale: 1, rotation: 0, duration: 0.7, ease: "back.out(1.6)" }); }
    idle(); showStep(state.step);
    track("Spin to Win Viewed", { trigger: why }, viewer());
  }
  function close() {
    if (!state.open || state.spinning) return;
    state.open = false;
    if (state.step === 1) save({ closedAt: Date.now() });
    cycle.pause(); winTl && winTl.kill();
    gsap.to(root, { opacity: 0, duration: reduce ? 0 : 0.25, onComplete: function () { root.hidden = true; document.documentElement.style.overflow = ""; refreshTab(); if (lastFocus && lastFocus.focus) lastFocus.focus(); } });   // tab back first, so focus can return to it
  }
  /* Every viewer is counted (Taylor, Oct 10 2026): an anonymous ID per browser, plus Klaviyo's own
     identifier when klaviyo.js already knows the visitor. Anonymous profiles cannot be emailed, so
     they are not active (billable) profiles. Signup rate = Spun events / Viewed events. */
  var sessionAid = "";
  function anonId() {
    try { var id = localStorage.getItem(KEY + "-aid"); if (!id) { id = "ero-" + Date.now().toString(36) + Math.random().toString(36).slice(2, 10); localStorage.setItem(KEY + "-aid", id); } return id; }
    catch (e) { return sessionAid || (sessionAid = "ero-" + Date.now().toString(36) + Math.random().toString(36).slice(2, 10)); }
  }
  function viewer() {
    var p = { anonymous_id: anonId() };
    try { var m = document.cookie.match(/__kla_id=([^;]+)/); if (m) { var k = JSON.parse(atob(decodeURIComponent(m[1]))); if (k.$exchange_id) p._kx = k.$exchange_id; } } catch (e) {}
    return p;
  }
  root.querySelector("[data-spin-close]").addEventListener("click", close);
  root.addEventListener("pointerdown", function (e) { if (e.target.hasAttribute && e.target.hasAttribute("data-spin-close-bg")) close(); });

  /* ═════ Official Rules lightbox: the rest of the popup is inert while it is open; its X, its own
     backdrop and Escape close the rules only, and focus goes back to the link ═════ */
  var rules = root.querySelector("[data-spin-rules]"), rulesClose = rules.querySelector("[data-spin-rules-close]");
  var behindRules = [root.querySelector(".ero-spin__scroll"), root.querySelector("[data-spin-close]")];
  var rulesOn = false, rulesFrom = null;
  function openRules(from) {
    if (rulesOn) return;
    rulesOn = true; rulesFrom = from;
    behindRules.forEach(function (n) { n.setAttribute("inert", ""); });
    gsap.killTweensOf(rules); rules.hidden = false;
    gsap.fromTo(rules, { opacity: 0 }, { opacity: 1, duration: reduce ? 0 : 0.25, ease: "power1.out" });   // opacity, not autoAlpha: the X must take focus now
    rules.querySelector("[data-spin-rules-body]").scrollTop = 0;
    try { rulesClose.focus({ preventScroll: true }); } catch (e) {}
  }
  function closeRules() {
    if (!rulesOn) return;
    rulesOn = false;
    behindRules.forEach(function (n) { n.removeAttribute("inert"); });
    gsap.killTweensOf(rules);
    gsap.to(rules, { opacity: 0, duration: reduce ? 0 : 0.2, ease: "power1.out", onComplete: function () { rules.hidden = true; } });
    var back = rulesFrom && rulesFrom.offsetParent !== null ? rulesFrom : behindRules[1];   // the link, unless its step has moved on
    try { back.focus({ preventScroll: true }); } catch (e) {}
  }
  root.querySelector("[data-spin-rules-open]").addEventListener("click", function () { openRules(this); });
  rulesClose.addEventListener("click", closeRules);
  rules.addEventListener("pointerdown", function (e) { if (e.target.hasAttribute && e.target.hasAttribute("data-spin-rules-close-bg")) closeRules(); });

  document.addEventListener("keydown", function (e) {
    if (!state.open) return;
    if (e.key === "Escape") { if (rulesOn) closeRules(); else close(); return; }   // the rules first, then the popup
    if (e.key !== "Tab") return;                                   // focus trap, inside the rules while they are open
    var f = Array.prototype.filter.call((rulesOn ? rules : root).querySelectorAll('button, [href], input:not([readonly]), [tabindex="0"]'), function (n) { return n.offsetParent !== null && !n.disabled; });
    if (!f.length) return;
    var a = f[0], z = f[f.length - 1];
    if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); } else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
  });

  /* ═════ Trigger (Taylor, Oct 10 2026): 5 s or desktop exit intent; not on cart, checkout or account;
     14 days after a close; never after signup; never over the cart drawer; never for visitors from our emails ═════ */
  /* the pieces are shared with the reopen tab (8.1c) */
  function offPage() { return /^\/(cart|checkout|checkouts|account)/.test(location.pathname); }
  function fromEmail() { return /[?&](_kx|utm_medium=email|utm_source=klaviyo)/i.test(location.search); }   // arrived from one of our emails
  function cooldownMs() { return (+root.getAttribute("data-cooldown-days") || 14) * 864e5; }
  function eligible() {
    var s = load();
    if (offPage()) return false;
    if (s.signedUp) return false;
    if (s.closedAt && Date.now() - s.closedAt < cooldownMs()) return false;
    if (fromEmail()) return false;
    return true;
  }
  function cartOpen() { var d = document.querySelector("cart-drawer"); return !!(d && (d.classList.contains("active") || d.hasAttribute("open"))); }
  function tryOpen(why) { if (state.open) return; if (cartOpen()) { setTimeout(function () { tryOpen(why); }, 2000); return; } open(why); }
  var forced = /[?&]ero-spintest=1/.test(location.search);       // dev testing: always open
    if (forced) tryOpen("test");
  else if (eligible()) {
    setTimeout(function () { tryOpen("delay"); }, (+root.getAttribute("data-delay") || 5) * 1000);
    if (window.matchMedia("(hover: hover) and (pointer: fine)").matches) {
      document.addEventListener("pointerout", function onOut(e) { if (!e.relatedTarget && e.clientY <= 0 && e.pointerType === "mouse") { document.removeEventListener("pointerout", onOut); tryOpen("exit"); } });
    }
  }

  /* ═════ Reopen tab (8.1c, docs/handoffs/8.1c-spin-tab/SPEC.md): a side tab on the left edge.
     Spin state (closed the popup without an email, within the cooldown): EVERY SPIN WINS!, opens step 1.
     Code state (spun in the last 14 days): YOUR {pct}% OFF CODE, opens straight to step 3 with the stored
     code, no second call to the prize server. The X hides it for this browser session only. ═════ */
  var tab = document.querySelector("[data-spin-tab]");
  var TAB_KEY = "ero-spin-tab-hidden", CODE_DAYS = 14, tabOff = false, tabMode = "", tabBtn = null, tabParts = [];
  var hoverOk = window.matchMedia("(hover: hover)");
  function tabHiddenThisSession() { if (tabOff) return true; try { return sessionStorage.getItem(TAB_KEY) === "1"; } catch (e) { return false; } }
  function tabWants() {                                           // "spin", "code" or "" (no tab)
    if (!tab || state.open || offPage() || tabHiddenThisSession()) return "";
    var s = load(), now = Date.now();
    if (s.signedUp) return now - s.signedUp < CODE_DAYS * 864e5 && s.code && +s.prize > 0 ? "code" : "";
    return s.closedAt && now - s.closedAt < cooldownMs() && !fromEmail() ? "spin" : "";
  }
  function turnTab(deg) {                                         // hover: the wheel turns, the tab does not lift
    if (reduce || !tabParts.length) return;
    gsap.to(tabParts, { rotation: deg, svgOrigin: "0 0", duration: 0.4, ease: "power2.out", overwrite: true });
  }
  function refreshTab() {
    if (!tab) return;
    var m = tabWants();
    tabMode = m;
    if (!m) { tab.hidden = true; return; }
    var pct = String(parseInt(load().prize, 10));
    tab.querySelector('[data-spin-tab-label="spin"]').hidden = m !== "spin";
    tab.querySelector('[data-spin-tab-label="code"]').hidden = m !== "code";
    if (m === "code") tab.querySelector("[data-spin-tab-pct]").textContent = pct;
    tabBtn.setAttribute("aria-label", m === "code" ? "Show your " + pct + "% off code" : "Spin to win, every spin wins");
    if (!tab.hidden) return;
    tab.hidden = false;
    if (reduce) return;                                           // reduced motion: no slide, no turn
    gsap.fromTo(tab, { xPercent: -100 }, { xPercent: 0, duration: 0.4, ease: "power2.out", overwrite: true, clearProps: "transform" });
    if (tabParts.length) gsap.fromTo(tabParts, { rotation: -360, svgOrigin: "0 0" }, { rotation: 0, svgOrigin: "0 0", duration: 1.2, ease: "power2.out", overwrite: true });
  }
  /* Code state: the popup as it is right after a spin (host B, the wheel resting on the first slice of the
     stored prize, that slice landed); open() then shows step 3. No spin and no winner strobe. */
  function restoreWon() {
    var s = load(), slice = -1;
    if (!s.code || !(+s.prize > 0)) return false;
    for (var i = 0; i < ORDER.length; i++) if (+PRIZES[ORDER[i]].pct === +s.prize) { slice = i; break; }
    state.prize = slice < 0 ? { pct: +s.prize } : PRIZES[ORDER[slice]]; state.code = String(s.code);
    if (slice >= 0) { state.slice = slice; state.rot = restRotation(slice); gsap.set(discEl, { rotation: state.rot }); markLanded(slice, true); }
    gsap.set(hostA, { autoAlpha: 0 }); gsap.set(hostB, { autoAlpha: 1 }); gsap.set(wheelBox, { opacity: 1 });
    fillPrize(); state.step = 3;
    return true;
  }
  if (tab) {
    tabBtn = tab.querySelector("[data-spin-tab-open]");
    /* everything in the wheel art turns except its defs and the gold pin (its last element), which stays at 12 like the popup's */
    var tabKids = tab.querySelector(".ero-spintab__wheel svg").children;
    for (var k = 0; k < tabKids.length - 1; k++) if (tabKids[k].tagName.toLowerCase() !== "defs") tabParts.push(tabKids[k]);
    tabBtn.addEventListener("click", function () {
      var won = tabMode === "code" && restoreWon();
      try { tabBtn.focus({ preventScroll: true }); } catch (e) {}  // Safari does not focus a clicked button; close() returns focus to lastFocus
      open(won ? "tab-code" : "tab");
      if (won) live.textContent = "You won " + state.prize.pct + " percent off. Your code is " + state.code + ".";
    });
    tabBtn.addEventListener("pointerenter", function (e) { if (e.pointerType !== "touch" && hoverOk.matches) turnTab(45); });
    tabBtn.addEventListener("pointerleave", function (e) { if (e.pointerType !== "touch" && hoverOk.matches) turnTab(0); });
    tab.querySelector("[data-spin-tab-hide]").addEventListener("click", function () {
      tabOff = true;
      try { sessionStorage.setItem(TAB_KEY, "1"); } catch (e) {}  // session only: closedAt / signedUp stay, so it returns next visit
      refreshTab();
    });
    /* the stylesheet loads async (media="print" until it loads): wait for it so the tab never shows unstyled */
    var tabCss = document.querySelector('link[href*="ero-spin-popup.css"]');
    if (tabCss && tabCss.media === "print") tabCss.addEventListener("load", refreshTab); else refreshTab();
  }

  })();
